/* eslint-disable @typescript-eslint/naming-convention */
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { AddressOptions } from './address.component.interface';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CreateForm } from '../data-picker/data-picker.interface';
import { Subscription } from 'rxjs';
import { ContactInfoService } from '../contact-info/contact-info.component.service';
import { TabsComponentService } from '../tabs-component/tabs-component.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { CustomersService } from 'app/core/services/customers/customers.service';
import { HotToastService } from '@ngneat/hot-toast';
import { BadgeOptions } from '../badge/badge.interface';
import { ZuperDrawerService } from '@zuper/components/zuper-drawer';

@Component({
  selector: 'app-address-component',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddressComponent implements OnInit {
  @Input() addressOptions: AddressOptions;
  @Output() selectedAddress: EventEmitter<any> = new EventEmitter();
  selectedAddressTab: string = 'allAddress';
  addressTabs: any[] = [
    {
      displayName: 'All Address',
      displayKey: 'all.address.label',
      dataKey: 'allAddress',
      rel: 'all_address',
      hasCount: false,
    },
    {
      displayName: 'New Address',
      displayKey: 'customer.manage.address.tabs.new',
      dataKey: 'newAddress',
      rel: 'new_address',
      hasCount: false,
    },
  ];

  addressType = [
    {
      label: 'Home',
      selected: true,
    },
    {
      label: 'Work',
      selected: false,
    },
    {
      label: 'Others',
      selected: false,
    },
  ];
  addressForm: UntypedFormGroup;
  contactAddressForm: string = 'contactAddressForm';
  addressFields: any = {
    contactFirstName: true,
    contactLastName: true,
    contactEmail: true,
    contactPhone: true,
    street: true,
    enableMapsAutoComplete: true,
    canTruncate: true,
    landmark: true,
    city: true,
    state: true,
    country: true,
    zipcode: true,
    latitude: false,
    longitude: false,
  };
  onTabChangeSubscription: Subscription;
  selectedTab: string;
  selectedAddressObj: any = {};
  mockAddressList: any = [];
  searchText: string = '';

  constructor(
    public utilityService: UtilityService,
    private contactInfoService: ContactInfoService,
    private dataCollectorService: DataCollectorService,
    private toast: HotToastService,
    private zuperDrawerService: ZuperDrawerService
  ) {}

  ngOnInit(): void {
    this.addressForm = new UntypedFormGroup({
      label: new UntypedFormControl('Home'),
      contactAddressForm: new UntypedFormGroup({}),
    });
    if (Object.keys(this.addressOptions)?.length > 0) {
      setTimeout(() => {
        if (!this.utilityService.isEmptyOrUndefined(this.addressOptions?.uid)) {
          this.selectedAddressTab = 'allAddress';
        }
        if (this.addressOptions?.selectedAddress?.street && Object.keys(this.addressOptions?.selectedAddress)?.length > 0) {
          this.selectedAddressObj = this.addressOptions?.selectedAddress;
        }
        this.mockAddressList = this.addressOptions?.addressList;

        this.toggleDrawer('allAddress');
      }, 100);
    }
  }

  changeViewMode(mode: string): void {
    this.selectedAddressTab = mode;
    if (this.selectedAddressTab === 'newAddress') {
      this.contactInfoService.address.next({});
      const editableValue = {
        label: 'Home',
        firstName: this.addressOptions?.prefillDetails?.firstName,
        lastName: this.addressOptions?.prefillDetails?.lastName,
        email: this.addressOptions?.prefillDetails?.email,
        phone: this.addressOptions?.prefillDetails?.phone,
      };
      this.contactInfoService.address.next(editableValue);
    }
  }

  setTabClasses(mode: string): any {
    return {
      'border-indigo-500 text-indigo-600': this.selectedAddressTab === mode,
      'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200':
        this.selectedAddressTab !== mode,
      'w-full': this.addressTabs.length < 2,
    };
  }

  getBadgeOptions(tabDetails): BadgeOptions {
    const badgeOption: BadgeOptions = {
      type: 'PRIMARY',
      displayKey: '',
      displayName: tabDetails.count,
    };
    return badgeOption;
  }

  updateAddress(): void {
    this.addressForm.markAllAsTouched();
    if (this.addressForm.valid) {
      const updatedAddress = {
        ...this.addressForm?.value?.contactAddressForm,
        geo_cordinates: [
          this.addressForm.value?.contactAddressForm?.latitude,
          this.addressForm.value?.contactAddressForm?.longitude,
        ],
        country: this.addressForm.value?.contactAddressForm?.country?.label,
        label: ['Home', 'Work'].includes(this.isAddressType)
          ? this.isAddressType
          : this.addressForm?.value?.label,
      };

      Object.keys(updatedAddress).forEach((element: any) => {
        if (
          ['contactAddressForm', 'phone', 'latitude', 'longitude'].includes(
            element
          )
        ) {
          delete updatedAddress[element];
        }
      });
      let payload: any = {};
      if (this.addressOptions?.addressModule === 'CUSTOMER') {
        payload = {
          customer: {
            customer_all_addresses: [
              ...this.addressOptions?.addressList.filter(
                (data: any) => data?.module === 'CUSTOMER'
              ),
              updatedAddress,
            ],
          },
          customer_uid: this.addressOptions.uid,
        };
      }
      this.dataCollectorService
        .putData(this.addressOptions.postApiUrl, payload)
        .subscribe(
          (response: any) => {
              this.selectedAddressObj = updatedAddress;
              this.selectedAddress.emit(this.selectedAddressObj);
              this.toggleDrawer('allAddress');
          },
          (error: any) => {
            
          }
        );
    }
  }

  updateSelectedLabel(type): void {
    this.addressType = this.addressType.map((data: any) => ({
      ...data,
      selected: data.label === type.label,
    }));
  }

  toggleDrawer(drawerName: string): void {
    const drawer = this.zuperDrawerService.getComponent(drawerName);
    if (drawer) {
      drawer.toggle();
    }
  }

  sendAddress(): void {
    if (this.selectedAddressTab && this.selectedAddressTab === 'newAddress') {
      this.updateAddress();
    } else {
      if (Object.keys(this.selectedAddressObj)?.length > 0) {
        this.selectedAddress.emit(this.selectedAddressObj);
        this.toggleDrawer('allAddress');
      }
    }
  }

  get isAddressType(): string {
    return this.addressType.filter((type: any) => type.selected)[0]?.label;
  }

  ischecked(address): boolean {
    return JSON.stringify(this.selectedAddressObj) === JSON.stringify(address);
  }

  valueChanged(event, address): void {
    if (event?.target.checked) {
      this.selectedAddressObj = address;
    }
  }
  addressDrawerOpen(event): void {
    if (!event) {
      this.selectedAddressObj = {};
      this.selectedAddress.emit(false);
    }
  }

  onModelChange(): void {
    const resultValue = this.mockAddressList.filter((data: any) => {
      let isExist = false;
      Object.keys(data).forEach((element: any) => {
        if (
          !['geo_cordinates', 'is_primary','point_coordinates'].includes(element) &&
          data[element]?.toLowerCase()?.indexOf(this.searchText.toLowerCase()) >= 0
        ) {
          isExist = true;
        }
      });
      if (isExist) {
        return data;
      }
    });
    this.addressOptions.addressList = resultValue;
  }
}
